module.exports = __webpack_public_path__ + "static/img/login-2.b393c1ab.png";